import { ListGroup, ListGroupItem } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { MODALS } from "@/constants/modals"
import { useStore } from "@/zustand/store"

export default function LectureAdditionalMaterialsModal() {
  const { t } = useTranslation()
  const modalData = useStore(
    (state) => state.modalsStates[MODALS.lecture.additionalMaterials]
  )
  const lecture = modalData?.lecture
  const course = modalData?.course

  const editModalState = useStore((state) => state.editModalState)

  if (!modalData) return null

  const materials =
    course?.course_additional_materials
      ?.filter((m) => lecture?.additional_material_ids?.includes(String(m.id)))
      .map((v) => ({
        url: v.link || "",
      })) || []

  return (
    <ListGroup>
      {lecture?.additional_material_ids?.map((materialId, index) => {
        const material = course?.course_additional_materials?.find(
          (m) => m.id === Number(materialId)
        )
        return (
          <ListGroupItem
            onClick={() => {
              editModalState(MODALS.lecture.previewAdditionalMaterial, {
                materials,
                index,
              })
            }}
            key={materialId}
            className="d-flex justify-content-between hoverable"
          >
            <p className="m-0">{material?.name}</p>
            <p className="m-0">
              (
              {Number(material?.type) === 1
                ? t("additionalMaterials.pdf")
                : t("additionalMaterials.video")}
              )
            </p>
          </ListGroupItem>
        )
      })}
    </ListGroup>
  )
}
